import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuestionnaireRoutingModule } from './questionnaire-routing.module';
import { SharedModule } from '@base-shared/shared.module';
import { EyrusSharedModule } from '@eyrus/shared/shared.module'
import { FormModules } from '@base-shared/shared-bootstraps';

import { QuestionnaireComponent } from './questionnaire.component';
import { QuestionnaireSplashComponent } from './splash/splash.component';
import { QuestionnaireFormComponent } from './form/form.component';
import { QuestionnaireQuestionTypeModalComponent } from './question-type-modal/question-type-modal.component';
import { QuestionnairePreviewComponent } from './preview/preview.component';
import { QuestionTypeListComponent } from './question-type-list/question-type-list.component';
import { QuestionTypeComponent } from './question-type/question-type.component';

@NgModule({
  declarations: [
    QuestionnaireComponent,
    QuestionnaireSplashComponent,
    QuestionnaireFormComponent,
    QuestionnaireQuestionTypeModalComponent,
    QuestionnairePreviewComponent,
    QuestionTypeListComponent,
    QuestionTypeComponent
  ],
  imports: [
    CommonModule,
    QuestionnaireRoutingModule,
    SharedModule,
    EyrusSharedModule,
    FormModules()
  ],
  entryComponents: [
    QuestionnaireQuestionTypeModalComponent
  ]
})
export class QuestionnaireModule { }
